export default __webpack_public_path__ + "static/media/3087.2b6cd830.jpg";